var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08594 17.9195L6.71033 16.1409C7.00611 16.0271 7.154 15.9703 7.29237 15.896C7.41527 15.83 7.53244 15.7539 7.64264 15.6684C7.7667 15.5721 7.87875 15.46 8.10284 15.236L17.5026 5.83619C18.4231 4.91572 18.4231 3.42333 17.5026 2.50286C16.5822 1.58238 15.0898 1.58238 14.1693 2.50285L4.76951 11.9026C4.54542 12.1267 4.43337 12.2388 4.3371 12.3628C4.25158 12.473 4.17544 12.5902 4.10947 12.7131C4.03519 12.8515 3.97831 12.9994 3.86455 13.2951L2.08594 17.9195ZM2.08594 17.9195L3.80104 13.4603C3.92377 13.1412 3.98513 12.9817 4.09039 12.9086C4.18237 12.8447 4.29619 12.8206 4.40618 12.8416C4.53205 12.8656 4.65292 12.9865 4.89467 13.2282L6.77725 15.1108C7.019 15.3526 7.13987 15.4734 7.16391 15.5993C7.18491 15.7093 7.16076 15.8231 7.09689 15.9151C7.02381 16.0204 6.86426 16.0817 6.54516 16.2044L2.08594 17.9195Z",
    stroke: "#6366F1",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil01);
export default __webpack_public_path__ + "static/media/pencil-01.696d822db69dd1e89053256ec0b677ae.svg";
export { ForwardRef as ReactComponent };